import React from 'react';
import { FaBox, FaBoxes, FaCashRegister, FaFileInvoiceDollar, FaFunnelDollar, FaHistory, FaHome, FaMoneyCheckAlt, FaNotesMedical, FaPeopleCarry, FaPrescriptionBottle, FaRegSun, FaSlidersH, FaUser, FaWarehouse } from "react-icons/fa";
import { FiCalendar, FiGrid, FiMessageCircle, FiRefreshCw, FiSettings, FiFileText, FiType, FiShoppingCart } from "react-icons/fi";

const iconMap = {
  dashboard: FaHome,
  staffUser: FaUser,
  chats: FiMessageCircle,
  calendar: FiCalendar,
  referral: FiRefreshCw,
  settings: FaRegSun,
  file: FiFileText,
  sales: FaCashRegister,
  purchase: FaBox,
  stock: FaBoxes,
  items: FaSlidersH,
  medicine: FaNotesMedical,
  inventory: FaWarehouse,
  supplier: FaPeopleCarry,
  transaction: FaMoneyCheckAlt,
  ledger: FaFileInvoiceDollar,
  OTC: FaPrescriptionBottle,
  tax: FaFunnelDollar,
  transactions: FaHistory
};

const IconRenderer = ({ iconName, className }) => {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent className={className} /> : null;
};

export default IconRenderer;
